export function scoreAnswer(correct, seconds, replayed = false) {
  if (!correct) return 0;
  return 60 + (replayed ? 0 : 40 * Math.max(0, Math.min(1, (5 - Math.max(.5, seconds)) / 4.5)));
}
export function median(values) {
  if (!values.length) return null;
  const sorted = [...values].sort((a,b) => a-b), mid = Math.floor(sorted.length/2);
  return sorted.length%2 ? sorted[mid] : (sorted[mid-1]+sorted[mid])/2;
}
export function shuffled(values, random = Math.random) {
  const copy = [...values];
  for (let i=copy.length-1;i>0;i--) {const j = Math.floor(random()*(i+1)); [copy[i],copy[j]]=[copy[j],copy[i]];}
  return copy;
}
export function answerLabel(word, mode) {
  return mode === 'target' || mode === 'ja' ? word.targetDefinition ?? word.ja ?? word.meaning : word.meaning;
}
export function makeChoices(word, deck, language, random = Math.random) {
  const label = w => answerLabel(w, language);
  const reading = w => w.reading || w.word;
  const labels = new Set([label(word)]);
  // Different readings and explanation labels avoid alternate forms becoming duplicate answers.
  const pool = shuffled(deck.filter(w => w.id !== word.id && reading(w) !== reading(word)), random);
  const distractors=[];
  for (const w of pool) {
    if (!labels.has(label(w))) {labels.add(label(w)); distractors.push(w);}
    if (distractors.length===3) break;
  }
  return shuffled([word,...distractors], random);
}
export function summarize(results) {
  return {score:results.length ? results.reduce((s,r)=>s+r.points,0)/results.length : 0,
    accuracy:results.length ? results.filter(r=>r.correct).length/results.length*100 : 0,
    time:median(results.filter(r=>r.correct).map(r=>r.seconds)), correct:results.filter(r=>r.correct).length};
}
export function recordAnswer(previous, result, now = Date.now()) {
  const r = previous || {attempts:0,correct:0,fastDays:[],streak:0,times:[]};
  const fast = result.correct && result.seconds <= 2 && !result.replayed;
  const day = new Date(now).toLocaleDateString('en-CA');
  const fastDays = fast ? [...new Set([...r.fastDays,day])] : r.fastDays;
  const streak = fast ? r.streak+1 : 0;
  const days = !result.correct ? 0 : !fast ? 1 : [1,3,7,14,30][Math.min(streak-1,4)];
  return {...r,attempts:r.attempts+1,correct:r.correct+Number(result.correct),fastDays,streak,
    times:result.correct ? [...r.times,result.seconds].slice(-10) : r.times,
    lastCorrect:result.correct,lastTime:result.seconds,lastAt:now,due:now+days*86400000,
    mastered:fastDays.length>=3 && streak>=3};
}
